import { z } from 'zod'

const codeRegex = /^[A-Za-z0-9._\-\/#&\s]*$/

export const businessUnitSchema = z.object({
  parent_id: z.coerce.number().optional().nullable(),
  name: z.string().min(1, 'Business unit name is required').max(255),
  business_code: z
    .string()
    .min(1, 'Business code is required')
    .max(50)
    .regex(codeRegex, 'Business code contains invalid characters'),
  descriptions: z.string().max(2000).optional().or(z.literal('')),
  active: z.boolean().default(true),
})

export type BusinessUnitFormData = z.infer<typeof businessUnitSchema>

